'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicVisitorContext = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = require('redux-actions');

var _VisitorContextDAO = require('../data/VisitorContextDAO');

var _AnalyticsActions = require('./AnalyticsActions');

var _VisitorContextActionTypes = require('../actionTypes/VisitorContextActionTypes');

var _UserInfoActionTypes = require('../actionTypes/UserInfoActionTypes');

var _UserInfo = require('../selectors/UserInfo');

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('VisitorContextActions');

function formWasTouched(state) {
  return [_UserInfo.getEmail, _UserInfo.getPassword, _UserInfo.getFirstName, _UserInfo.getLastName, _UserInfo.getDomain, _UserInfo.getCompanyName].reduce(function (acc, func) {
    return acc || func(state) != null;
  }, false);
}

var succeedGettingVisitorContext = (0, _reduxActions.createAction)(_VisitorContextActionTypes.SUCCEED_GETTING_VISITOR_CONTEXT);
var failGettingVisitorContext = (0, _reduxActions.createAction)(_VisitorContextActionTypes.FAIL_GETTING_VISITOR_CONTEXT);
var requestVisitorContext = (0, _reduxActions.createAction)(_VisitorContextActionTypes.REQUEST_VISITOR_CONTEXT);
var storeUserData = (0, _reduxActions.createAction)(_UserInfoActionTypes.STORE_USERDATA);

function handlePublicVisitorContextSuccess(visitorContext) {
  return function (dispatch, getState) {
    dispatch(succeedGettingVisitorContext());
    (0, _AnalyticsActions.trackEvent)('interaction', { action: 'visitor-context-new-user' });

    if (!formWasTouched(getState())) {
      dispatch(storeUserData(_extends({}, visitorContext, {
        isFromContext: true
      })));
      (0, _AnalyticsActions.trackEvent)('interaction', { action: 'visitor-context-filled' });
    } else {
      (0, _AnalyticsActions.trackEvent)('interaction', { action: 'visitor-context-not-filled' });
    }
  };
}

function handlePublicVisitorContextError(status) {
  return function (dispatch) {
    dispatch(failGettingVisitorContext());

    if (status === 409) {
      (0, _AnalyticsActions.trackEvent)('interaction', {
        action: 'visitor-context-existing-user'
      });
    } else if (status === 404) {
      (0, _AnalyticsActions.trackEvent)('interaction', {
        action: 'visitor-context-unable-to-fetch-email-validation'
      });
    } else {
      if (status === 429) {
        (0, _AnalyticsActions.trackEvent)('interaction', {
          action: 'visitor-context-rate-limited'
        });
      }
      if (status >= 500) {
        LOG.error('Failed to fetch public visitor context', {
          extra: {
            status: status
          }
        });
      }
    }
  };
}

var getPublicVisitorContext = exports.getPublicVisitorContext = function getPublicVisitorContext(utk) {
  return function (dispatch) {
    dispatch(requestVisitorContext());
    (0, _AnalyticsActions.trackEvent)('interaction', { action: 'visitor-context-fetch' });
    (0, _VisitorContextDAO.fetchPublicVisitorContext)(utk).then(function (visitorContext) {
      if (visitorContext) {
        //undefined on no content
        dispatch(handlePublicVisitorContextSuccess(_extends({}, visitorContext, {
          domain: visitorContext.companyDomain
        })));
      } else {
        //no content
        (0, _AnalyticsActions.trackEvent)('interaction', {
          action: 'visitor-context-contact-not-found'
        });
      }
    }).catch(function (_ref) {
      var status = _ref.status;

      dispatch(handlePublicVisitorContextError(status));
    });
  };
};